import { createSlice } from "@reduxjs/toolkit";
import ApiClient, { createFetchErrorMessage } from "../../../utils/api/ApiClient";

const initialState = { loading:null, result:null, list:[], totalElements:null, message:null };
const schoolListSlice = createSlice({
	name:'school/list',
	initialState,
	reducers:{
		loading:(state)=>{
			state.loading = true;
			state.result = false;
			state.list  = null;
		},
		fetch:(state, action)=>{
			return {...state, ...action.payload, loading:false, result:true};
		},
		error:(state, action)=>{
			state.loading = false;
			state.message = action.payload;
			state.result = true;
		}
	}

});

export default schoolListSlice.reducer;
export const schoolListActions = schoolListSlice.actions;

export function fetchSchoolList(keyword = '', page = 0) {
	return function (dispatch) {
		dispatch( schoolListActions.loading() );
		const { promise } = ApiClient({
			method:"post",
			url: `/api/school/list?size=20&page=${page}`,
			data:{keyword}
		});
		promise.then( res=>{
			dispatch( schoolListActions.fetch(res.data) );
		}).catch(err=>{
			const errorData = createFetchErrorMessage(err);
			dispatch( schoolListActions.error(errorData.message) );
		});
		return promise;
	}// return
}//end